import { render, staticRenderFns } from "./Cenario.vue?vue&type=template&id=9044ec68&scoped=true"
import script from "./Cenario.vue?vue&type=script&lang=js"
export * from "./Cenario.vue?vue&type=script&lang=js"
import style0 from "./Cenario.vue?vue&type=style&index=0&id=9044ec68&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9044ec68",
  null
  
)

export default component.exports